import produce from "immer"
import { ChapterZone } from "../../models/models"
import type { PagingActions, PagingOptions } from "../../models/types"
import { loadPagingOptions } from "../../utils/sort-table.utils"
import { CHAPTER_LOAD, CHAPTER_LOAD_DEFAULT, CHAPTER_LOAD_LIST, CHAPTER_LOAD_LIST_OPTIONS } from "./chapter.actions"
import type { Chapter, ChapterActions, IChapterState } from "./chapter.types"

const chapterInitialState: IChapterState = {
  chapter: getEmptyChapter(),
  pagingOptions: {
    currentPage: 0,
    pageSize: 10,
    totalPages: 0
  }
}

export function chapterReducer(
  currentState: IChapterState | undefined,
  action: ChapterActions | PagingActions
): IChapterState {
  const state = currentState ?? chapterInitialState
  switch (action.type) {
    case CHAPTER_LOAD_DEFAULT: {
      return loadChapter(state, getEmptyChapter())
    }
    case CHAPTER_LOAD_LIST: {
      return loadChapterList(state, action.payload as Chapter[])
    }
    case CHAPTER_LOAD: {
      return loadChapter(state, action.payload as Chapter)
    }
    case CHAPTER_LOAD_LIST_OPTIONS: {
      return loadPagingOptions(state, action.payload as PagingOptions)
    }
    default: {
      return state
    }
  }
}

function loadChapterList(currentState: IChapterState, chapters: Chapter[]): IChapterState {
  return produce(currentState, (draftState: IChapterState) => {
    draftState.chapters = chapters
  })
}

function loadChapter(currentState: IChapterState, chapter: Chapter): IChapterState {
  return produce(currentState, (draftState: IChapterState) => {
    draftState.chapter = chapter
  })
}

function getEmptyChapter(): Chapter {
  return {
    name: "",
    thumbnailUrl: "",
    order: 0,
    zone: ChapterZone.TOP,
    licenceIds: []
  }
}
